module.exports = __webpack_public_path__ + "img/index-6.d05bb121.png";